<template>
  <div class="video-container">
    <video autoplay muted loop class="fullscreen-video">
      <source src="@/assets/swiperpic/homevideo.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    <img :src="currentLang === 'en' ? require('@/assets/swiperpic/videotextEn.png') : require('@/assets/swiperpic/videotext.png')" alt="Overlay Image" class="centered-image">
  </div>
</template>

<script>
export default {
  name: 'VideoH',
  computed: {
    currentLang() {
      return this.$i18n.locale;  // 获取当前语言
    }
  }
}
</script>

<style scoped>
.video-container {
  position: relative;
  width: 100%;
  height: 100vh; /* 设置高度为视口高度 */
  overflow: hidden;
}

.fullscreen-video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw; /* 设置宽度为视口宽度 */
  height: 100vh; /* 设置高度为视口高度 */
  object-fit: cover; /* 使视频保持比例并填满整个容器 */
  transform: translate(-50%, -50%);
  z-index: -1; /* 确保视频在其他内容的后面 */
}

/* .navigation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
} */

.centered-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2; /* 确保图片在视频和tabbar的上层 */
  max-width: 50%; /* 可根据需要调整 */
  max-height: 100%; /* 可根据需要调整 */
}

@media (max-width: 768px) {
  .video-container {
  position: relative;
  width: 100%;
  height: 40vh; 
  overflow: hidden;
}

  .fullscreen-video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw; /* 设置宽度为视口宽度 */
  height: 50vh; /* 设置高度为视口高度 */
  object-fit: cover; /* 使视频保持比例并填满整个容器 */
  transform: translate(-50%, -50%);
  z-index: -1; /* 确保视频在其他内容的后面 */
}
}
</style>


// WEBPACK FOOTER //
// src/views/home/video.vue